import cx from 'clsx';
import React from 'react';

import { ReactComponent as ThinArrowIcon } from '@assets/svg/thin-arrow.svg';

import type { IFacilityLevelActiveWithMultiplicationFactorValue } from '../../model/multiplicationFactors';
import CostSavingCalculationInput from '../CostSavingCalculationInput/CostSavingCalculationInput';
import style from './style.module.scss';

interface IProps {
  row: IFacilityLevelActiveWithMultiplicationFactorValue;
  expandedRows: Record<number, boolean>;
  level?: number;
  setExpandedRows: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
}

const CostSavingCalculationItem: React.FC<IProps> = ({ row, expandedRows, level = 1, setExpandedRows }) => {
  const paddingLeft = `${level * 15}px`;

  const hasChildren = row.children.length > 0;
  const isNotFirstLevel = level > 1;
  const isOpen = expandedRows?.[row.id];

  return (
    <>
      <tr
        className={cx(style.costSavingSettingsBodyRow, {
          [style.costSavingLocationSettingsBodyRow]: isNotFirstLevel,
        })}
      >
        <td className={style.facilityColumn} style={{ paddingLeft }}>
          <span
            className={cx(style.arrowWrapper, { [style.hideArrow]: !hasChildren })}
            onClick={() => setExpandedRows((prev) => ({ ...prev, [row.id]: !isOpen }))}
          >
            <ThinArrowIcon className={cx({ [style.expandArrow]: isOpen })} />
          </span>
          <span className={style.name}>{row.name}</span>
        </td>
        <td>
          <CostSavingCalculationInput row={row} />
        </td>
      </tr>
      {isOpen &&
        row.children.map((child) => (
          <CostSavingCalculationItem
            key={child.id}
            row={child}
            level={level + 1}
            expandedRows={expandedRows}
            setExpandedRows={setExpandedRows}
          />
        ))}
    </>
  );
};

export default CostSavingCalculationItem;
